const imgTeamGraphic1Catalog = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/0742553d-37fd-4197-a5b0-32f0c371bdff.png";
const img2026923372 = "./assets/figma/4035b339-96f6-4927-b1b2-b4d052e226e0.png";
const img2026923373 = "./assets/figma/7a6dc028-9361-4c44-964f-8aa3a1994c16.png";
const img12061 = "./assets/figma/00689bd6-b6e6-499a-a3c6-686dae57eabc.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img5F7482990599C916Png3 = "./assets/figma/23c7af17-4de0-4bc4-8324-06de9991695e.png";
const img5F7482990599C916Png2 = "./assets/figma/775501f9-1712-4e12-844e-ee2fab1ed6fc.png";
const imgRectangle253 = "./assets/figma/7f2eeb4a-5ff5-4a5f-a3c5-fec5b1cc5ec1.png";
const imgRectangle254 = "./assets/figma/7ea13cf4-c4c0-487c-9c17-44df8d3961de.png";
const imgRectangle255 = "./assets/figma/a4a44624-9509-48dc-9c03-181761b4b6ba.png";
const imgRectangle256 = "./assets/figma/c9c7f78d-6c54-46e9-8f67-cc14fcbde569.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/4329ab02-bd1e-473d-8da9-d8ecc919547f.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/46555a1a-7513-434c-85f5-7dfeec719be4.svg";
const imgRectangle247 = "./assets/figma/0a0f13d0-9cdf-414b-9cf7-8d46976f3008.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGraphic1Catalog() {
  return (
    <div className="s0 s1" data-node-id="875:1699" data-name="TEAM_GRAPHIC_1_CATALOG">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s440 s441 s9 s10 s442" src={imgTeamGraphic1Catalog} />
        </div>
      </div>
      <div className="s2 s12 s13 s14 s15" data-node-id="875:1701" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s940 s22" data-node-id="875:1702">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:1703">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1704">
            PROJECT OVERVIEW
          </p>
          <div className="s35 s36 s0 s28 s37 s34 s38" data-node-id="875:1705">
            <p className="s39 s40">
              POSTER · A2 · 2<br aria-hidden />
              BRAND BOOK · B5 · 1
            </p>
            <p className="s39 s40">​</p>
            <p className="s39">​</p>
          </div>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:1706">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:1707">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1708">
            MEMBERS
          </p>
          <div className="s35 s36 s0 s28 s37 s34" data-node-id="875:1709">
            <p className="s39 s40">강지운</p>
            <p className="s39 s40">김세원</p>
            <p className="s39 s40">노아연</p>
            <p className="s39">정다혜</p>
          </div>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s941 s54" data-node-id="875:1710">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s942 s57" data-node-id="875:1711">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:1712">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:1713">
          <p className="s39 s40">{`그래픽 1팀은 DING AI LAB의 Play Lab 콘셉트와 브랜드 시스템을 포스터와 브랜드북으로 시각화했다. `}</p>
          <p className="s39 s40">
            {`아이디어와 AI가 연결되고 실험되는 과정을 구슬과 투명한 파이프로 표현하고, Play·Flow·Connection·Modular의 네 가지 키워드를 중심으로 `}
            <br aria-hidden />
            {`일관된 브랜드 정체성을 구축했다. 브랜드북에는 8가지 AI별 Tube System과 응용 사례를 담았으며, 구슬이 튜브를 통과하면서 색·질감·형태를 `}
          </p>
          <p className="s39 s40">{`얻고 조합 순서에 따라 다른 결과로 발전하는 과정을 그래픽 시스템으로 구성했다. 오프화이트와 민트 계열의 색상, `}</p>
          <p className="s39">투명한 소재와 구조적인 레이아웃을 적용해 정돈된 실험실 분위기를 완성했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s943 s27 s29 s61 s62 s54" data-node-id="875:1714">
        GRAPHIC 1
      </p>
      <div className="s2 s16 s17 s24 s944 s18 s19 s20 s945 s66" data-node-id="875:1715">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="875:1716">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="875:1717">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1718">
            <div className="s192 s69 s659 s340 s0 s70 s198 s348 s71" data-node-id="875:1719" data-name="이미지 2026. 9. 2. 오후 3.38 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1720" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1721" />
            <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:1722">
              POSTER 1
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1723">
            <div className="s192 s69 s946 s340 s0 s70 s198 s348 s71" data-node-id="875:1724" data-name="이미지 2026. 9. 2. 오후 3.37 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923372} />
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1725" />
            <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:1726" />
            <p className="s23 s192 s31 s94 s947 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:1727">
              POSTER 2
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1728">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="875:1729" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s7 s948 s9 s10 s949" src={img2026923373} />
              </div>
            </div>
            <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:1730" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1731" />
            <p className="s23 s192 s31 s94 s950 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:1732">
              CATALOG
            </p>
          </div>
        </div>
      </div>
      <div className="s2 s951 s328 s942 s952" data-node-id="875:1733" data-name="이미지 1206 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12061} />
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:1734">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:1735" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:1736">
          <div className="s111 s0 s28 s112" data-node-id="875:1737" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:1742">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:1743">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:1744">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1745">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1746">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:1747">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1748">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1749">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:1750">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1751">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1752">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:1767">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:1768">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:1781" data-name="PROJECT_CATEGORY_TABS_GRAPHIC1">
        <p className="s23 s31 s32 s27 s0 s28 s137 s138 s54" data-node-id="875:1782">
          GRAPHIC 1
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="772:1435" data-name="PROJECT_CATEGORY_TABS_GRAPHIC1">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="772:1436" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="772:1437">
              POSTER1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="772:1438" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="772:1439">
              POATER2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="772:1440" data-name="TAB_CATALOG">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="772:1441">
              CATALOG
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:146" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
      <div className="s106 s2 s67 s126 s953" data-node-id="1018:357">
        <div className="s2 s5 s954 s153 s156 s157 s953 s158" data-node-id="1018:358" />
        <p className="s23 s2 s31 s32 s955 s27 s29 s160 s956 s54" data-node-id="1018:359">
          CATALOG
        </p>
        <div className="s2 s957 s958 s959 s960" data-node-id="1018:360" data-name="5f7482990599c916.png 3">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img5F7482990599C916Png3} />
        </div>
        <div className="s2 s961 s227 s962 s963" data-node-id="1018:361" data-name="5f7482990599c916.png 2">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s7 s964 s9 s10 s965" src={img5F7482990599C916Png2} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s715 s27 s29 s137 s966 s54" data-node-id="1018:362">
          LAYOUT
        </p>
        <div className="s106 s2 s67 s126 s967" data-node-id="1018:363">
          <div className="s106 s2 s968 s126 s165 s4 s145 s146 s967 s522" data-node-id="1018:364">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s523 s26 s524 s27 s29 s969 s526" data-node-id="1018:365">
            <div className="s16 s17 s24 s172 s26 s0 s28 s528" data-node-id="1018:366">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="1018:367">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34 s38" data-node-id="1018:368">
                <p className="s175 s40">[추가 레이아웃 제작 프롬프트 — 03-2]</p>
                <p className="s175 s40">​</p>
                <p className="s175">Recreate the supplied reference image as closely as possible, matching its composition, tube placement, proportions, materials, colors, and lighting. Use the reference as the primary visual guide.Create an ultra-wide 3D illustration with an aspect ratio of approximately 2.82:1. Exclude the dark gray outer screenshot border. The artwork should fill the entire canvas.COMPOSITION AND CAMERAUse a straight-on, orthographic front view. The pipe paths lie parallel to the image plane, with no noticeable perspective convergence or foreshortening.Place the tubes exclusively along the left and right edges. The left arrangement occupies approximately the leftmost 20% of the canvas, and the right arrangement occupies approximately the rightmost 22%.Preserve a continuous, completely empty central area approximately 58% of the canvas width, extending from the top edge to the bottom edge. Keep this area the same pale background color.Make the two edge arrangements asymmetrical, with slightly different heights, bends, and overlaps. Several tubes extend beyond the top, bottom, and side edges, so their paths appear to continue outside the frame.LEFT-SIDE ARRANGEMENTNear the upper left, a transparent tube descends from the top edge near the inner boundary of the left cluster, curves left through a rounded 90-degree elbow, and continues horizontally toward the left edge. A teal sphere sits inside its horizontal section near the bend.In front of this upper arrangement, another mint tube enters from the left, bends downward, continues vertically, turns right around mid-height, then bends downward again and exits through the bottom edge. Its rightmost vertical section defines the inner boundary of the left cluster.Include an additional partially cropped vertical glass tube at the far left edge, with a partially visible teal sphere inside it.Near the lower left, a separate horizontal tube enters from the left edge and curves downward through a clear glass elbow. Place a pale mint sphere just below this bend. The tube continues beyond the bottom edge.RIGHT-SIDE ARRANGEMENTAt the upper right, an isolated tube enters from the top, curves right, and continues horizontally beyond the right edge. Its bend is frosted mint, while its horizontal section is transparent and contains a pale mint sphere.Leave a visible background gap beneath this upper tube.In the middle and lower right, arrange several offset pipe paths entering from the right edge. Include a transparent horizontal section containing a saturated teal sphere, a large rounded bend descending near the inner boundary of the right cluster, and a lower bend returning toward the right.At the bottom right, a separate transparent tube enters horizontally from the right edge, contains a pale mint sphere, and curves downward to exit the bottom edge.Use shallow, clearly readable overlaps where separate tubes cross in the reference. Keep each tube structurally distinct.TUBE GEOMETRYUse cylindrical tubes of nearly uniform outer diameter, approximately 9% of the image height. Construct their paths from straight horizontal and vertical segments joined by smooth, moderately rounded 90-degree elbows.Maintain consistent thickness through every bend. Use clean circular cross-sections and precise transitions between components. The pipes should feel like carefully assembled modular objects.MATERIALSAlternate between clear glass, softly frosted translucent mint material, and slightly more saturated translucent turquoise sections.The clear sections reveal the internal spheres and show subtle wall thickness, delicate refraction along the edges, and elongated soft white reflections.The frosted mint sections gently diffuse light, with soft tonal gradients and a smooth finish. Material changes are marked by thin, flush circular seams, without bulky collars or metal fittings.SPHERESPlace a small number of mint and teal spheres inside the tubes, matching the reference positions. Each sphere is slightly smaller than the tube’s outer diameter and fits naturally within its interior.Vary the spheres between softly translucent pale mint and deeper glossy teal. Give the glossier spheres a small, soft white highlight.COLOR AND LIGHTINGUse an extremely pale mint-white background. Keep the palette restricted to white, pale aqua, seafoam mint, and restrained turquoise.Use bright, broad, diffused studio lighting. Maintain low contrast, gentle shading, and subtle depth. Keep cast shadows extremely faint. Preserve slightly deeper teal accents in selected tube sections and spheres.FINISHCreate a refined, softly luminous 3D render with clean geometry and delicate glass detail. Retain only a very fine, barely perceptible grain similar to the reference. The overall surface should remain smooth.No text, logos, dark border, central objects, or additional decorative elements.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="1018:369">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="1018:370">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="1018:371">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s970 s971 s185 s195 s187 s222 s683 s972 s973" data-node-id="1018:324">
        <div className="s192 s974 s975 s0 s198 s976 s28 s977" data-node-id="1018:319">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle253} />
        </div>
        <div className="s203 s974 s975 s0 s198 s976 s28 s977" data-node-id="1018:322">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle254} />
        </div>
        <div className="s192 s974 s975 s0 s206 s976 s28 s977" data-node-id="1018:320">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle255} />
        </div>
        <div className="s203 s975 s0 s206 s199 s28 s977" data-node-id="1018:323">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle256} />
        </div>
      </div>
    </div>
  );
}